import React from "react";
import ReactDOM from 'react-dom';
import {Button} from "react-bootstrap";
import ModalBase from "./ModalBase";
import Receipt from "../report/Receipt";
import Spinner from "../feedback/Spinner";

import "../../../assets/sass/components/modals/receipt-modal.scss";

class ReceiptModal extends ModalBase {

    constructor(props) {
        super(props)
    
        this.state = {
             isLoading: false
        }
    }
    

    renderBody = () => (
        <>
            <Receipt />
            <Receipt exportOnly ref="receipt" />
        </>
    );

    renderHeader = () => {
    };

    renderFooter = () => {
        const { isLoading } = this.state;

        return (
            <Button variant="primary" className="lg" onClick={() => this.downloadReceiptPdf()}>
                {isLoading ? (
                    <Spinner variant="only-light" loading={isLoading} />
                ) : (
                    'Download PDF'
                )}
            </Button>
        )
    };

    modalClassname = () => "receipt-modal";

    downloadReceiptPdf = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.reportRef().createPdf(this.exportedFileName(), this.handleGenerateEnd);
        }, 10);
    };

    handleGenerateEnd = () => {
        this.setState({ isLoading: false });
    }

    reportNode = () => ReactDOM.findDOMNode(this.reportRef());
    reportRef = () => this.refs.receipt;
    exportedFileName = () => 'Purchase Receipt';

    static defaultProps = {
        ...super.defaultProps,
        type: "pdf",
        size: "md",
    };
}

export default ReceiptModal;
